import { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, openModal } from '../../features/commonSlice'
import CommonModal from '../atoms/modal/CommonModal'
import ButtonCustom from '../atoms/button/ButtonCustom'
import CategoryTable from './CategoryTable'
import InputCustom from '../atoms/input/InputCustom'
import styles from './budgetTrackerStyle.module.scss'
import SelectCustom from '../atoms/select/SelectCustom'
import { getKazooVendors } from '../../features/vendorSlice'
import { useParams } from 'react-router-dom'
import { createCategoryLineItem } from '../../features/kazooEventSlice'
import { toastHelper } from '../../util/toastHelper'
import DateCustom from '../atoms/input/DateCustom'


const SingleCategoryTab = ({ title }) => {
	const dispatch = useDispatch()
    const { kazooId } = useParams()
	const categoryAllocations = useSelector(
		(state) => state.kazooEvent?.categoryAllocations
	)
	const budget = useSelector((s) => s.kazooEvent.budget)
    const vendors = useSelector((s) => s.vendor.vendors)?.map((vendor) => (
        {
            value: vendor?._id || vendor.email,
            label: vendor?.businessName || vendor.email,
            hasAccount: (vendor?._id != null)
        }
    ))
	const modal = useSelector((s) => s.common.modal)

	const [formData, setFormData] = useState({
		item: '',
        vendor: {},
		total: 0,
		paid: 0,
        dueDate: null
	})

	const lineItems = categoryAllocations ? categoryAllocations[title] : []

	const allocated = () => {
		let total = 0
		lineItems?.map((item) => {
			total += item.total
		})
		return total
	}

	const handleClose = () => {
		dispatch(closeModal())
		setFormData({
			item: '',
            vendor: {},
			total: 0,
			paid: 0,
		})
	}

	const handleSubmit = (e) => {
		e.preventDefault()

        if(!formData.item){
            return toastHelper('Must include item name', 'error')
        }

        if(!formData.dueDate) {
            return toastHelper('Must choose a due date', 'error')
        }

        if(formData.total < formData.paid){
            return toastHelper('Total amount cannot be less than paid amount', 'error')
        }

        if(formData.total <= 0){
            return toastHelper('Total amount must be greater than 0', 'error')
        }

        if(formData.paid < 0) {
            return toastHelper('Paid amount must be positive', 'error')
        }
        // return console.log(formData)
        dispatch(createCategoryLineItem({
            kazooId,
            category: title,
            lineItem: formData
        }))

		handleClose()
	}

    useEffect(() => {
        dispatch(getKazooVendors(kazooId))
    }, [dispatch, kazooId])

	return (
		<div className={styles.categoryTabView}>
			<div className={styles.headerWrp}>
				<div className={styles.left}>
					<Typography variant="h4">{title} Budget</Typography>
					<ul className={styles.list}>
						{/* <li>Regional Avg: $3,300</li> */}
						<li>Allocated: ${allocated().toLocaleString()}</li>
						<li>
							Bucket: {((allocated() / budget) * 100).toFixed(2)}%
						</li>
					</ul>
				</div>
				<div className={styles.right}>
					<ButtonCustom
						variant="outlined"
						size="lg"
						onClick={() => dispatch(openModal('addLineItem'))}
					>
						+ Add Line Item
					</ButtonCustom>
				</div>
			</div>
			<div className={styles.table}>
				<CategoryTable
                    rows={lineItems}
                    category={title}
                    vendors={vendors}
                />
			</div>

			<CommonModal
				open={modal === 'addLineItem'}
				handleClose={handleClose}
				heading="Add Line Item"
				footerContent={
					<>
						<ButtonCustom variant="outlined" onClick={handleClose}>
							Cancel
						</ButtonCustom>
						<ButtonCustom onClick={handleSubmit}>Save</ButtonCustom>
					</>
				}
			>
				<form onSubmit={handleSubmit} className={styles.formWrp}>
					<Grid container spacing={1.5}>
						<Grid size={{ xs: 12, md: 12 }}>
							<InputCustom
								label="Item Name"
								type="text"
								name="item"
								value={formData.item}
								data={formData}
								setDataFunction={setFormData}
								placeholder="Item Name"
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
							<SelectCustom
                                label='Vendor'
                                options={[...vendors, {label: 'None', value: 'none'}]}
                                renderValueAsLabel={true}
                                value={formData.vendor?.name === 'None' ? 'none' : formData.vendor?.vendorId || formData.vendor?.email || ''}
                                setDataFunction={(selectedOption) => {
                                    let vendor = {}
                                    if (!selectedOption || selectedOption.value === 'none') {
                                        vendor = { name: 'None' }
                                    } else {
                                        vendor = { name: selectedOption.label }
                                        if(selectedOption.hasAccount){
                                            vendor.vendorId = selectedOption.value
                                        } else 
                                            vendor.email = selectedOption.value
                                    }
                                    setFormData({
                                        ...formData,
                                        vendor
                                    })
                                }}
                            />
						</Grid>
						<Grid size={{ xs: 12, md: 12 }}>
                            <DateCustom
								name="dueDate"
								value={formData.dueDate}
								data={formData}
								setDataFunction={setFormData}
                                label='Due date'
                                data_cy = 'date'
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 6 }}>
							<InputCustom
								label="Total"
								type="number"
								name="total"
								value={formData.total}
								data={formData}
								setDataFunction={setFormData}
								placeholder="Total"
							/>
						</Grid>
						<Grid size={{ xs: 12, md: 6 }}>
							<InputCustom
								label="Paid"
								type="number"
								name="paid"
								value={formData.paid}
								data={formData}
								setDataFunction={setFormData}
								placeholder="Paid"
							/>
						</Grid>
					</Grid>
				</form>
			</CommonModal>
		</div>
	)
}

export default SingleCategoryTab
